<template>
  <div class="reservation-calendar" v-watermark>
    <div class="header">
      <div class="item date">
        <div class="label">预约日期</div>
        <div class="value" @click="onDateShow">
          <div class="text">
            {{ formatTime(dates.current).format("YYYY年MM月DD日") }}
          </div>
          <div class="arrow">
            <van-icon name="play" />
          </div>
        </div>
      </div>
      <div class="item doctor">
        <div class="label">医生</div>
        <div class="value" @click="onTableShow">
          <div class="text">
            {{ doctorComputed ? doctorComputed.name : "暂无" }}
          </div>
          <div class="arrow">
            <van-icon name="play" />
          </div>
        </div>
      </div>
    </div>
    <div class="tags">
      <div class="tag" v-for="(item, index) in tags.list" :key="index">
        <div class="label">{{ item.label }}</div>
        <div class="value" :style="item.style"></div>
      </div>
    </div>

    <div class="tables">
      <table>
        <thead>
          <tr>
            <td></td>
            <td>时段/医生</td>
            <td>
              <template v-if="doctorComputed">
                <span>{{ doctorComputed.name }}</span>
                <span>（</span>
                <span v-if="doctorComputed.scNo === 'BC0005'">假</span>
                <span v-else-if="doctorComputed.scNo === 'BC0006'">休</span>
                <span v-else-if="doctorComputed.scNo === 'BC0003'">外</span>
                <span v-else-if="doctorComputed.scNo === 'BC0004'">出</span>
                <span v-else>{{ doctorComputed.details.length }}</span>
                <span>）</span>
              </template>
              <template v-else>-</template>
            </td>
          </tr>
        </thead>
        <tbody>
          <template v-for="(item, index) in dates.times">
            <template v-if="item.type === 'space'">
              <tr class="space">
                <td :colspan="3"></td>
              </tr>
            </template>
            <template v-else>
              <tr v-for="(itm, idx) in item.list" :key="`${index}-${idx}`">
                <td class="bold" :rowspan="item.list.length" v-if="idx === 0">
                  {{ item.name }}
                </td>
                <td>{{ itm.name }}</td>
                <td>
                  <template v-if="doctorComputed">
                    <template v-for="(user, userIndex) in doctorComputed.details">
                      <div
                        class="cell"
                        :style="onTagStyle(user.askType, user.firstAsk)"
                        :key="userIndex"
                        v-if="
                          onDateCheck(
                            user.apptStartTime,
                            user.apptEndTime,
                            itm.startTime,
                            itm.endTime
                          )
                        "
                      >
                        {{ user.userMemberName }}
                      </div>
                    </template>
                  </template>
                </td>
                <!-- <template v-for="doctor in tables.list">
                    <td>
                      <template v-for="(user, userIndex) in doctor.details">
                        <div
                          class="cell"
                          :style="onTagStyle(user.askType, user.firstAsk)"
                          :key="userIndex"
                          v-if="
                            onDateCheck(
                              user.apptStartTime,
                              user.apptEndTime,
                              itm.startTime,
                              itm.endTime
                            )
                          "
                        >
                          {{ user.userMemberName }}
                        </div>
                      </template>
                    </td>
                  </template> -->
              </tr>
            </template>
          </template>
        </tbody>
      </table>
    </div>

    <van-action-sheet v-model="dates.show">
      <div class="dates-selector">
        <van-datetime-picker
          v-model="dates.active"
          type="date"
          title="选择日期"
          @confirm="onDateConfirm"
          @cancel="dates.show = false"
        />
      </div>
    </van-action-sheet>

    <van-action-sheet v-model="tables.show">
      <div class="tables-selector">
        <van-picker
          show-toolbar
          value-key="name"
          :columns="tables.list"
          @confirm="onTableConfirm"
          @cancel="onTableCancel"
        />
      </div>
    </van-action-sheet>
  </div>
</template>
<script>
import { formatTime } from "@/hooks/function";
import { AskMethodType } from "@/hooks/useAsk/type";
import api from "@/utils/request";

export default {
  data() {
    return {
      dates: {
        show: false,
        current: new Date(),
        active: null,
        times: [],
      },
      tags: {
        list: [
          {
            label: "电话首诊",
            code: "00",
            style: {
              background: "#f66c6a",
              color: "#fff",
            },
          },
          {
            label: "视频首诊",
            code: "10",
            style: {
              background: "#4479fc",
              color: "#fff",
            },
          },
          {
            label: "电话复诊",
            code: "01",
            style: {
              background: "#fce1e0",
              color: "#f66c6a",
            },
          },
          {
            label: "视频复诊",
            code: "11",
            style: {
              background: "#d0eafe",
              color: "#4479fc",
            },
          },
        ],
      },
      tables: {
        show: false,
        loading: false,
        index: 0,
        list: [],
      },
    };
  },
  computed: {
    doctorComputed() {
      return this.tables.list[this.tables.index];
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    formatTime,
    init() {
      const date = formatTime(this.dates.current).format("YYYY-MM-DD");
      this.dates.times = [
        {
          type: "morning",
          name: "上午",
          list: this.onDateTimesCreate(date, "08:30", "12:00"),
        },
        {
          type: "space",
          name: "",
          list: [],
        },
        {
          type: "afternoon",
          name: "下午",
          list: this.onDateTimesCreate(date, "13:00", "21:00"),
        },
      ];
      this.onDataGet(date);
    },
    async onDataGet(date) {
      this.tables.loading = true;
      try {
        const { data } = await api({
          method: "get",
          url: "/doctor-service/doctorAppt/board",
          params: {
            date,
          },
        });
        this.tables.index = 0;
        this.tables.list = data;
      } catch (error) {}
      this.tables.loading = false;
    },
    // 时间段生成
    onDateTimesCreate(date, start, final, duration = 30) {
      let startTime = new Date(`${date} ${start}`).getTime();
      let endTime = 0;
      const finalTime = new Date(`${date} ${final}`).getTime();
      const res = [];
      while (endTime < finalTime) {
        endTime = startTime + duration * 1000 * 60;
        res.push({
          date,
          startTime: formatTime(startTime).format("YYYY-MM-DD HH:mm:00"),
          endTime: formatTime(endTime).format("YYYY-MM-DD HH:mm:00"),
          name: `${formatTime(startTime).format("HH:mm")}-${formatTime(
            endTime - 1000 * 60
          ).format("HH:mm")}`,
        });
        startTime = endTime;
      }
      return res;
    },
    onDateShow() {
      this.dates.active = this.dates.current;
      this.dates.show = true;
    },
    onDateConfirm() {
      if (this.dates.current !== this.dates.active) {
        this.dates.current = this.dates.active;
        this.init();
      }
      this.dates.show = false;
    },
    onTableShow() {
      this.tables.show = true;
    },
    onTableConfirm(event, index) {
      this.tables.index = index;
      this.tables.show = false;
    },
    onTableCancel() {
      this.tables.show = false;
    },
    onTagStyle(askType, firstAsk) {
      // 第一位：0电话、1视频；第二位：0初诊、1复诊
      const code = `${askType === AskMethodType.VIDEO ? 1 : 0}${firstAsk === 0 ? 1 : 0}`;
      const find = this.tags.list.find((row) => row.code === code);
      return find ? find.style : null;
    },
    onDateCheck(start, end, startTime, endTime) {
      return (
        new Date(formatTime(start).format("YYYY-MM-DD HH:mm:00")).getTime() >=
          new Date(startTime).getTime() &&
        new Date(formatTime(end).format("YYYY-MM-DD HH:mm:00")).getTime() <=
          new Date(endTime).getTime()
      );
    }
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/base";
.reservation-calendar {
  height: calc(100vh - 97px);
  background: #fff;
  margin: -15px -10px;
  padding: 15px;
  box-sizing: border-box;
  font-size: 16px;
  .header {
    @include flex(center, space-between);
    padding-top: 10px;
    .item {
      @include flex(center);
      cursor: pointer;
      .value {
        height: 30px;
        border: 1px solid #eee;
        margin-left: 10px;
        @include flex(center);
        border-radius: 4px;
        .text {
          padding: 0 6px;
          min-width: 3em;
          text-align: center;
        }
        .arrow {
          padding: 0 8px;
          height: 30px;
          @include flex(center);
          background: #f4f4f4;
          .van-icon {
            transform: rotate(90deg);
          }
        }
      }
    }
  }
  .tags {
    @include flex(center, $wrap: wrap);
    font-size: 14px;
    padding-bottom: 20px;
    padding-top: 10px;
    margin-left: -25px;
    .tag {
      @include flex(center);
      white-space: nowrap;
      margin-top: 10px;
      margin-left: 25px;
      .value {
        width: 20px;
        height: 20px;
        border-radius: 4px;
        margin-left: 10px;
      }
    }
  }
  .tables {
    font-size: 14px;
    padding-bottom: 15px;
    table {
      width: 100%;
      table-layout: fixed;
      border-collapse: collapse;
      td {
        border: 1px solid #ebeef5;
        padding: 9px;
        text-align: center;
        &:nth-child(-n + 2) {
          width: 100px;
        }
        &:first-child {
          width: 60px;
        }
        &.bold {
          font-weight: bold;
        }
      }
      thead {
        td {
          white-space: nowrap;
          &:not(:first-child) {
            background: #f5f7fa;
            color: #333;
            font-weight: bold;
            text-align: center;
          }
        }
      }
      tr {
        &.space {
          td {
            width: 100%;
          }
        }
      }
      tbody {
        td {
          min-width: 100px;
          .cell {
            display: inline-block;
            background: #f4f4f4;
            border-radius: 4px;
            padding: 5px 20px;
            margin: 3px;
            white-space: nowrap;
          }
        }
      }
    }
  }
}
</style>
